import React, { useState } from "react";
import { useWebHaptics } from "web-haptics/react";

export default function HapticsTest() {
  const { trigger, isSupported } = useWebHaptics();
  const [log, setLog] = useState("");

  const playSuccess = () => {
    setLog("Triggered: Success");
    try {
      trigger([
        { duration: 30 },
        { delay: 60, duration: 40, intensity: 1 },
      ]);
    } catch (e) {
      console.error(e);
    }
  };

  const playNudge = () => {
    setLog("Triggered: Nudge");
    try {
      trigger([
        { duration: 80, intensity: 0.8 },
        { delay: 80, duration: 50, intensity: 0.3 },
      ]);
    } catch (e) {
      console.error(e);
    }
  };

  const playError = () => {
    setLog("Triggered: Error");
    try {
      trigger([
        { duration: 40, intensity: 0.7 },
        { delay: 40, duration: 40, intensity: 0.7 },
        { delay: 40, duration: 40, intensity: 0.9 },
        { delay: 40, duration: 50, intensity: 0.6 },
      ]);
    } catch (e) {
      console.error(e);
    }
  };

  const playBuzz = () => {
    setLog("Triggered: Buzz");
    try {
      trigger(
        [
          { duration: 1000 },
        ],
        { intensity: 1 }
      );
    } catch (e) {
      console.error(e);
    }
  };

  const playSoft = () => {
    setLog("Triggered: Soft");
    try {
      trigger([
        { duration: 40 },
      ]);
    } catch (e) {
      console.error(e);
    }
  };

  const playSelection = () => {
    setLog("Triggered: Selection");
    try {
      trigger(
        [
          { duration: 8 },
        ],
        { intensity: 0.3 }
      );
    } catch (e) {
      console.error(e);
    }
  };

  const buttons = [
    {
      title: "Success",
      onClick: playSuccess,
      bg: "bg-[#D4F5E1]",
      border: "border-[#c1ebd0]",
      text: "text-[#10B981]",
    },
    {
      title: "Nudge",
      onClick: playNudge,
      bg: "bg-[#D8EDFF]",
      border: "border-[#c4e4ff]",
      text: "text-[#3B82F6]",
    },
    {
      title: "Error",
      onClick: playError,
      bg: "bg-[#FFD9DC]",
      border: "border-[#fbc5c9]",
      text: "text-[#EF4444]",
    },
    {
      title: "Buzz",
      onClick: playBuzz,
      bg: "bg-[#FFF0D4]",
      border: "border-[#ffe4b8]",
      text: "text-[#F59E0B]",
    },
    {
      title: "Soft",
      onClick: playSoft,
      bg: "bg-[#EDE9FE]",
      border: "border-[#DDD6FE]",
      text: "text-[#8B5CF6]",
    },
    {
      title: "Selection",
      onClick: playSelection,
      bg: "bg-[#F3E8FF]",
      border: "border-[#E9D5FF]",
      text: "text-[#A855F7]",
    },
  ];

  return (
    <div className="fixed inset-0 h-[100dvh] w-full bg-[#F8FAFC] flex flex-col items-center justify-center p-4 font-sans select-none overflow-hidden touch-none">
      <div className="w-full max-w-sm flex flex-col items-center justify-center">
        {/* Buttons Grid */}
        <div className="grid grid-cols-2 gap-3.5 w-full max-w-[340px]">
          {buttons.map((btn) => (
            <button
              key={btn.title}
              type="button"
              onClick={btn.onClick}
              className={`h-24 sm:h-28 rounded-[24px] ${btn.bg} active:scale-95 transition-transform flex items-center justify-center shadow-sm hover:opacity-90 cursor-pointer border ${btn.border}`}
            >
              <span className={`${btn.text} font-bold text-lg tracking-wide`}>
                {btn.title}
              </span>
            </button>
          ))}
        </div>

        {/* Status / Log display */}
        <div className="mt-4 text-center min-h-[28px]">
          {log && (
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 bg-gray-100 px-3 py-1.5 rounded-full inline-block">
              {log}
            </p>
          )}
          {isSupported === false && (
            <p className="text-xs text-amber-600 mt-2 bg-amber-50 px-3 py-1.5 rounded-lg border border-amber-200">
              ⚠️ Vibration/Haptics API may not be supported or enabled on this browser/device.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
